import React, { ChangeEventHandler } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import DashboardHeader from './DashboardHeader';

interface Props {
    boardType: 'hunt_groups_multiple' | 'team_custom';
    onDescriptionChanged: ChangeEventHandler<HTMLInputElement>;
    userDescription?: string;
    setFocusOnNameField?: boolean;
}
const DashboardSectionHeader = ({
    onDescriptionChanged,
    userDescription,
    boardType,
    setFocusOnNameField = false,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="px-3 pb-1.5">
            <DashboardHeader boardType={boardType} />
            <input
                id={'description'}
                aria-label={i18next.t('wallboard.description_user.title')}
                placeholder={i18next.t('wallboard.description_user.title')}
                autoComplete={'off'}
                autoFocus={setFocusOnNameField}
                onChange={onDescriptionChanged}
                value={userDescription}
                maxLength={45}
                className="focus-ring w-full border-b bg-white text-start text-sm"
            />
        </div>
    );
};

export default React.memo(DashboardSectionHeader);
